import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      height: 40,
    },
  }),
  { name: 'MenuSearchField' }
);
